// Pulls stage percentages out of a free-text payment term so a custom entry like "30-40-30" or
// "30% + 40% + 30%" can fill a milestone table the same way a master-data schedule does. Single
// percentages ("100% Full Payment") and non-split text ("Net 30 Days") return null — nothing to link.
export function parseStagePercents(text: string): number[] | null {
  if (!text) return null;
  const withPct = [...text.matchAll(/(\d+(?:\.\d+)?)\s*%/g)].map((m) => parseFloat(m[1]));
  if (withPct.length >= 2) return withPct;
  if (withPct.length === 1) return null;
  const parts = [...text.matchAll(/(\d+(?:\.\d+)?)\s*%?\s*[-–—/]/g)].map((m) => parseFloat(m[1]));
  if (parts.length >= 1) {
    const tail = text.match(/(\d+(?:\.\d+)?)\s*%?\s*$/);
    if (tail) parts.push(parseFloat(tail[1]));
  }
  return parts.length >= 2 ? parts : null;
}

// Names the stages the way the sales forms do: what the schedule row calls it, else the position
// in the split.
export function stageName(index: number, count: number, description?: string): string {
  return `Stage ${index + 1}: ${description?.trim() || (index === 0 ? 'Advance' : index === count - 1 ? 'Final Delivery' : `Phase ${index + 1}`)}`;
}
